import React, { Component } from "react"

export default class OOP extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">Olives on Porter</p>
            <p className="portdesctext">Worked in close collaboration with brand owner to update brand logo, develop brand identity, produce website, product labels, product stickers, & product design.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href="http://www.olives-on-porter.com" target="_blank" rel="noopener noreferrer"><p className="linktext">Site</p></a>
        </div>
      </div>
  )
}
}

